import { render, staticRenderFns } from "./solevelnew.vue?vue&type=template&id=cb851382&scoped=true&"
import script from "./solevelnew.vue?vue&type=script&lang=js&"
export * from "./solevelnew.vue?vue&type=script&lang=js&"
import style0 from "./solevelnew.vue?vue&type=style&index=0&id=cb851382&scoped=true&lang=less&"
import style1 from "./solevelnew.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb851382",
  null
  
)

export default component.exports